<template>
  <premium-detail :is-create="false" />
</template>

<script>
export default {
  name: 'EditPremium',
  components: {
    PremiumDetail: () => import('./detail')
  }
}
</script>
